/*
var ftzam = ftzam || {};
( function () {
    'use strict';

     ftzam.track = function () {
     if ( jQuery.cookie( 'trackedWorkshops' ) === null ) {
     jQuery.ajax( {
     url: '/track-workshops',
     type: 'GET'
     } ).done( function ( data ) {
     var jHtml = jQuery( data );
     eval( jHtml.find( '#TrackWorkshopsScript' ).html() )
     jQuery.cookie('trackedWorkshops', 'yes', { expires: 1 });
     } ).error( function ( error ) {
     console.error( error );
     } );
     }
     };
}() );
*/

var espresso = espresso || {};
(function () {
	'use strict';

	$(document).ready(function () {
		(function () {
			var input = $('#ServiceCatalog_NewProduct_ShortDescription');
			input.on('keyup', function (e) {
				$('#characters').text(160 - e.target.value.length);
			});
		}());
	})
}());


$( 'button' ).on( 'click', function () {
    $( '.master-workshop-administration-delivery-hours input' ).blur();
} );

espresso.maps.helpers.icon = function ( type ) {
    var icons = {
        standard: {
            url: '/Files/Templates/Designs/ftzmaster/assets/img/brand-specifics/automester-marker-icon.png',
            anchor: new google.maps.Point( 11, 11 ),
            scaledSize: new google.maps.Size( 48, 26 ),
            permissions: false,
            name: ''
        },
        webshopBooking: {
            url: '/Files/Templates/Designs/ftzmaster/assets/img/brand-specifics/automester-marker-icon.png',
            anchor: new google.maps.Point( 11, 11 ),
            scaledSize: new google.maps.Size( 48, 26 ),
            permissions: true,
            name: 'Webshop / Book tid online'
        },
        webshop: {
            url: '/Files/Templates/Designs/ftzmaster/assets/img/brand-specifics/automester-marker-icon.png',
            anchor: new google.maps.Point( 11, 11 ),
            scaledSize: new google.maps.Size( 48, 26 ),
            permissions: true,
            name: 'Webshop'
        },
        booking: {
            url: '/Files/Templates/Designs/ftzmaster/assets/img/brand-specifics/automester-marker-icon.png',
            anchor: new google.maps.Point( 11, 11 ),
            scaledSize: new google.maps.Size( 48, 26 ),
            permissions: true,
            name: 'Book tid online'
        },
        selected: {
            url: '/Files/Templates/Designs/ftzmaster/assets/img/brand-specifics/automester-marker-icon.png',
            anchor: new google.maps.Point( 11, 11 ),
            scaledSize: new google.maps.Size( 48, 26 ),
            permissions: false,
            name: ''
        }
    };

    if ( type === undefined ) {
        return icons;
    }
    else {
        return icons[ type ];
    }
};

master.settings.maps.apiKey = 'AIzaSyCnijwTO9WMAIS8oQ5ADgpFLSbYKV2aza8';

// when user clicks on accept terms the checkboxes auto checks
(function () {
	var acceptedTop = $('#EcomOrderCustomerAcceptedTop');
	var acceptedBottom = $('#EcomOrderCustomerAccepted');

	if (acceptedTop.length && acceptedBottom.length) {
		var acceptTermsBtn = $('#accept-terms-btn');
		acceptTermsBtn.click(function () {
			acceptedBottom.prop("checked", true);
			acceptedTop.prop("checked", true);
		});
	}
})();